<template>
  <div class="checkout-wrapper">
    <!-- 结算页面 -->
    <div class="page-container">
      <div class="page-header">
        <router-link to="/cart">&lt;&nbsp;返回购物车</router-link>
        <div class="page-title">订单结算</div>
      </div>
      <div class="page-content">
        <div class="order-extra">
          <el-form :model="checkoutForm" :rules="checkoutFormRules" ref="checkoutFormRef">
            <!-- 配送方式 -->
            <div class="extra-item shipping-type-box">
              <div class="extra-item-header">
                <div class="extra-item-title">配送方式</div>
                <!-- <span class="shipping-hits">(只支持申通快递、圆通速递、EMS标准快递)</span> -->
              </div>
              <div class="extra-body">
                <div :class="['choose-option', shippingMethod == 1 ? 'active' : '']" @click="setShippingMethod(1)">
                  <i class="iconfont tick">&#xe605;</i>
                  <i class="iconfont car-icon">&#xe601;</i>
                  <span class="option-name">顺丰快递</span>
                </div>
              </div>
            </div>
            <div class="spliter"></div>
            <!-- 配送信息 -->
            <div class="extra-item shipping-info-box">
              <div class="extra-item-header">
                <div class="extra-item-title">配送信息</div>
                <button type="button" v-if="address && address.length" class="extra-item-btn" @click="addAddress">
                  + 添加地址
                </button>
                <span v-else class="shipping-hits">*为必填项</span>
              </div>
              <div class="extra-body">
                <div class="address-box">
                  <!-- 没有地址 -->
                  <template v-if="!address || !address.length">
                    <div class="form-wrapper">
                      <el-form :model="newAddress" :rules="newAddressRules" ref="newAddress">
                        <div class="fieldset">
                          <div class="fieldset-l">
                            <div class="field-row two-field">
                              <el-form-item prop="username" class="username">
                                <el-input v-model.trim="newAddress.username" placeholder="*收货人姓名"></el-input>
                              </el-form-item>
                              <el-form-item prop="sex" class="user-title">
                                <el-select v-model="newAddress.sex" placeholder="*称谓">
                                  <el-option label="先生" value="1"></el-option>
                                  <el-option label="女士" value="2"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="field-row">
                              <el-form-item prop="regions">
                                <el-cascader :options="districts" :props="regionProps" v-model="newAddress.regions"
                                  :clearable="true" placeholder="*请选择地址"></el-cascader>
                              </el-form-item>
                            </div>
                            <div class="field-row">
                              <el-form-item prop="postcode">
                                <el-input type="number" v-model.trim="newAddress.postcode"
                                  placeholder="邮寄编码"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="fieldset-r">
                            <div class="field-row">
                              <el-form-item prop="mobile">
                                <el-input v-model.trim="newAddress.mobile" placeholder="*手机号码"></el-input>
                              </el-form-item>
                            </div>
                            <div class="field-row">
                              <el-form-item prop="detail">
                                <el-input v-model.trim="newAddress.detail" placeholder="*详细地址"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="form-actions">
                          <div class="isdefault" @click="setDefault(!newAddress.isDefault)">
                            <i class="iconfont">{{
                              newAddress.isDefault ? "&#xedaf;" : "&#xec58;"
                            }}</i>
                            <span>设为默认地址</span>
                          </div>
                          <el-button class="new-address" :disabled="saveStatus"
                            @click="saveAddress">添加并使用该地址</el-button>
                        </div>
                      </el-form>
                    </div>
                  </template>
                  <template v-else>
                    <div class="address-item" v-for="(item, i) in address" :key="i" @click="setAddress(item)">
                      <div class="address-info">
                        <div class="address-checkbox">
                          <i class="iconfont">{{
                            selectedAddress.id == item.id
                              ? "&#xe6a7;"
                              : "&#xe7c9;"
                          }}</i>
                        </div>
                        <div class="address-detail">
                          <div class="text-row user-info">
                            <span class="username" :title="`${item.username}`">{{
                              item.username
                            }}</span>
                            <span class="mobile">{{ item.mobile }}</span>
                          </div>
                          <span class="address-parts" v-if="!isTaiwanHKMacau(item.province)"
                            :title="`${item.province}${item.city}${item.county}${item.detail}`">
                            {{ item.province }}{{ item.city }}{{ item.county
                            }}{{ item.detail }}
                          </span>
                        </div>
                      </div>
                      <div class="address-action">
                        <template v-if="item.isDefault">
                          <span class="default">默认地址</span>
                        </template>
                        <template v-else>
                          <span class="no-default"></span>
                        </template>
                        <div class="address-btns">
                          <i class="iconfont del-icon" @click.stop="delAddress(item)">&#xe606;</i>
                          <i class="iconfont edit-icon" @click.stop="editAddress(item)">&#xe618;</i>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="spliter"></div>
            <!-- 优惠券 -->
            <div class="extra-item" :class="{ 'discount-disabled': isDiscountDisabled }">
              <div class="extra-item-header">
                <div class="extra-item-title">优惠券</div>
              </div>
              <div class="extra-body">
                <div class=" coupon-box">
                  <el-form-item prop="coupon">
                    <el-select v-model="checkoutForm.coupon" placeholder="请选择优惠券" clearable
                      :popper-append-to-body="false" @change="confirmDiscount">
                      <el-option v-for="(item, index) in couponList" :key="index"
                        :label="`${item.title}（有效期：${item.start_time}至${item.end_time}）`" :value="item.coupon_id">
                        <div>
                          <p class="title">{{ item.title }}</p>
                          <p class="sub-title">{{ `有效期：${item.start_time}至${item.end_time}` }}</p>
                        </div>
                        <span class="iconfont-ot-website selected-icon">&#xe611;</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- 使用积分 -->
            <div class="extra-item integral-item" :class="{ 'discount-disabled': isDiscountDisabled }">
              <div class="extra-item-header">
                <div class="extra-item-title">使用积分</div>
                <div class='points-tip'>您有{{ crm.points || 0 }}积分可用</div>
              </div>
              <div class="extra-body">
                <div class="integral-box">
                  <el-form-item prop="integral">
                    <el-input type="number" v-model.trim="checkoutForm.integral" placeholder="请输入需要抵扣的积分"
                      @change="confirmDiscount"></el-input>
                    <div class="extra-tip">{{ checkoutPointTip }}</div>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="spliter"></div>
            <!-- 支付方式 -->
            <div class="extra-item payment-box">
              <div class="extra-item-header">
                <div class="extra-item-title">支付方式</div>
              </div>
              <div class="extra-body">
                <!-- <div :class="['choose-option', paymentMethod == 1 ? 'active' : '']" @click="setPaymentMethod(1)">
                <i class="iconfont tick">&#xe605;</i>
                <i class="iconfont ali-pay">&#xe600;</i>
                <span class="option-name">支付宝支付</span>
              </div>
              <div :class="['choose-option', paymentMethod == 2 ? 'active' : '']" @click="setPaymentMethod(2)">
                <i class="iconfont tick">&#xe605;</i>
                <i class="iconfont wx-pay">&#xe62b;</i>
                <span class="option-name">微信支付</span>
              </div> -->
                <div :class="[
                  'choose-option',
                  item.value == paymentMethod ? 'active' : '',
                ]" v-for="(item, i) in allowPayMethod" :key="`PayMethod-${i}`" @click="setPaymentMethod(item.value)">
                  <i class="iconfont tick">&#xe605;</i>
                  <i :class="['iconfont', item.iconCls]" v-html="item.iconText"></i>
                  <span class="option-name">{{ item.text }}</span>
                </div>
              </div>
            </div>
            <div class="spliter"></div>
            <!-- 发票信息 -->
            <div class="extra-item invoice-box">
              <div class="extra-item-header">
                <div class="extra-item-title">发票信息</div>
                <div class="invoice-action" @click="setInvoice">
                  <i class="iconfont">{{ invoice ? "&#xedaf;" : "&#xec58;" }}</i>
                  <span>电子发票</span>
                </div>
              </div>
              <div class="extra-body" v-if="invoice">
                <div class="invoice-box">
                  <div class="invoice-switch">
                    <div class="invoice-switch-item">
                      <i class="iconfont">&#xe654;</i>增值税普通发票（电子发票）
                    </div>
                  </div>
                  <el-select :class="['invoice-title', invoice.title ? '' : 'invalid']" v-model="invoice.title"
                    placeholder="*请选择发票抬头，个人或企业">
                    <el-option value="1" label="个人"></el-option>
                    <el-option value="2" label="企业"></el-option>
                  </el-select>
                  <el-input class="invoice-name" v-model.trim="invoice.name" placeholder="*请输入抬头名称"
                    maxlength="50"></el-input>
                  <el-input class="invoice-code" v-model.trim="invoice.code" :placeholder="`${invoice.title == 2 ? '*' : ''}纳税人识别号${invoice.title == 2 ? '' : '(选填)'
                    }`" maxlength="50"></el-input>
                </div>
              </div>
            </div>
          </el-form>
          <div class="accept-box accept-box-p">
            <div class="accept-content">
              <i class="iconfont" @click="setAcceptTerms">{{
                isAcceptTerms ? "&#xedaf;" : "&#xec58;"
              }}</i>
              <span>*</span>我已阅读并同意<a href="/cms/terms-and-conditions">销售条款</a>
            </div>
            <div class="tip" v-show="showTermsTip">请勾选销售条款</div>
          </div>
          <div class="payment-action">
            <button class="pay-now" :disabled="submitStatus" @click="createOrder">
              立即支付
            </button>
          </div>
        </div>
        <!-- 订单详情 -->
        <div class="order-detail">
          <!-- 订单摘要 -->
          <div class="extra-item order-summary-box">
            <div class="extra-item-header">
              <div class="extra-item-title">订单详情</div>
            </div>
            <div :class="['extra-body', 'kv-items', isDiscount ? 'has-discount' : '']">
              <div class="kv-line">
                <span class="kv-name">商品总额</span>
                <span class="kv-value"><span class="rmb-symbol">￥</span>
                  {{ (checkoutData.original_subtotal || 0) | filterPrice }}</span>
              </div>
              <div class="kv-line">
                <span class="kv-name">优惠金额</span>
                <span class="kv-value" @click="openDiscountPopup"><span class="rmb-symbol">￥</span>
                  {{ (checkoutData.discount_amount || 0) | filterPrice }}</span>
                  <i class="iconfont icon-right-arrow"
                    v-if="isDiscount"
                    @click="openDiscountPopup"
                  >&#xe628;</i>
              </div>
              <div class="kv-line">
                <span class="kv-name">使用积分</span>
                <span class="kv-value">
                  {{ checkoutData.pointsDeducted || 0 }}积分</span>
              </div>
              <div class="kv-line">
                <span class="kv-name">运费</span>
                <span class="kv-value"><span class="rmb-symbol">￥</span>
                  {{ (checkoutData.shipping || 0) | filterPrice }}</span>
              </div>
              <div class="kv-line">
                <span class="kv-name">总计（共{{ list | countify }}件）</span>
                <span class="kv-value"><span class="rmb-symbol">￥</span>
                  {{ (checkoutData.amount || 0) | filterPrice }}</span>
              </div>
            </div>
          </div>
          <!-- 商品列表 -->
          <div class="extra-item order-detail-box" v-if="list && list.length">
            <div class="extra-item-header">
              <div class="extra-item-title">
                商品（共{{ list | countify }}件）
              </div>
            </div>
            <template v-if="list.length > 3">
              <div class="extra-body goods-items" style="height: 500px">
                <vue-scroll>
                  <div class="pdp-item" v-for="(item, i) in list" :key="i">
                    <div class="pdp-item-content">
                      <div class="pdp-image" v-if="item.cover || item.images">
                        <router-link :to="`/detail/${item.goodsId}-${item.color.id}`">
                          <img :src="item.images[0]" />
                        </router-link>
                      </div>
                      <div class="pdp-detail">
                        <div class="pdp-info">
                          <div class="pdp-name">
                            <router-link :to="`/detail/${item.goodsId}-${item.color.id}`">{{ item.name }}</router-link>
                          </div>
                          <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                            <div v-for="(label, index) in item.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
                              {{ label }}
                            </div>
                          </template>
                          <div class="pdp-skus">
                            <div class="pdp-sku-item" v-if="item.color">
                              <span class="sku-name">颜色</span>：
                              <span class="sku-value">{{ item.color.name }}</span>
                            </div>
                            <div class="pdp-sku-item" v-if="item.size">
                              <span class="sku-name">尺码</span>：
                              <span class="sku-value">{{ item.size.name }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="pdp-subTotal">
                          <div class="pdp-money">
                            <p>
                              <span class="rmb-symbol">￥</span>{{ item.price }}
                            </p>
                            <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                              ￥{{ (item.original_price || 0) | filterPrice }}
                            </p>

                          </div>
                          <span class="pdp-count">x {{ item.quantity }}</span>
                        </div>
                      </div>
                    </div>
                    <p class="markdown-tip" v-if="item.is_mark_down"><span
                        class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>
                    <p class="markdown-tip" v-if="item.dont_use_coupon_and_point === 1"><span
                        class="iconfont-ot-website">&#xe60f;</span><span>{{ commonConfig['DONT_USE_COUPON_AND_POINT_TIP'] || '此商品不适用积分抵现及优惠券结算' }}</span></p>
                  </div>
                </vue-scroll>
              </div>
            </template>
            <template v-else>
              <div class="extra-body goods-items">
                <div class="pdp-item" v-for="(item, i) in list" :key="i">
                  <div class="pdp-item-content">
                    <div class="pdp-image" v-if="item.cover || item.images">
                      <router-link :to="`/detail/${item.goodsId}-${item.color.id}`">
                        <img :src="item.images[0]" />
                      </router-link>
                    </div>
                    <div class="pdp-detail">
                      <div class="pdp-info">
                        <div class="pdp-name">
                          <router-link :to="`/detail/${item.goodsId}-${item.color.id}`">{{ item.name }}</router-link>
                        </div>
                        <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                          <div v-for="(label, index) in item.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
                            {{ label }}
                          </div>
                        </template>
                        <div class="pdp-skus">
                          <div class="pdp-sku-item" v-if="item.color">
                            <span class="sku-name">颜色</span>：
                            <span class="sku-value">{{ item.color.name }}</span>
                          </div>
                          <div class="pdp-sku-item" v-if="item.size">
                            <span class="sku-name">尺码</span>：
                            <span class="sku-value">{{ item.size.name }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="pdp-subTotal">
                        <div class="pdp-money">
                          <p>
                            <span class="rmb-symbol">￥</span>{{ item.price }}
                          </p>
                          <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                            ￥{{ (item.original_price || 0) | filterPrice }}
                          </p>

                        </div>
                        <span class="pdp-count">x {{ item.quantity }}</span>
                      </div>
                    </div>
                  </div>
                  <p class="markdown-tip" v-if="item.is_mark_down"><span
                      class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>  
                  <p class="markdown-tip" v-if="item.dont_use_coupon_and_point === 1"><span
                      class="iconfont-ot-website">&#xe60f;</span><span>{{ commonConfig['DONT_USE_COUPON_AND_POINT_TIP'] || '此商品不适用积分抵现及优惠券结算' }}</span></p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="accept-box accept-box-m">
          <div class="accept-content">
            <i class="iconfont" @click="setAcceptTerms">{{
              isAcceptTerms ? "&#xedaf;" : "&#xec58;"
            }}</i>
            <span>*</span>我已阅读并同意<a href="/cms/terms-and-conditions">销售条款</a>
          </div>
          <div class="tip" v-show="showTermsTip">请勾选销售条款</div>
        </div>
        <!-- 支付按钮：768像素时启用 -->
        <div class="order-extra-pay">
          <button class="pay-now" :disabled="submitStatus" @click="createOrder">
            立即支付
          </button>
        </div>
      </div>
    </div>
    <!-- 添加地址弹窗 -->
    <div class="dialog new-address-dialog" v-if="showAddressDialog">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">
            {{ newAddress.id ? "编辑" : "新增" }}地址<span class="title-hits">(*为必填项)</span>
          </div>
          <i class="iconfont dialog-close" @click="hideAddressDialog">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="form-wrapper">
            <el-form :model="newAddress" :rules="newAddressRules" ref="newAddress">
              <div class="fieldset">
                <div class="fieldset-l">
                  <div class="field-row two-field">
                    <el-form-item prop="username" class="username">
                      <el-input v-model.trim="newAddress.username" maxlength="30" placeholder="*收货人姓名"></el-input>
                    </el-form-item>
                    <el-form-item prop="sex" class="user-title">
                      <el-select v-model="newAddress.sex" placeholder="*称谓">
                        <el-option label="先生" value="1"></el-option>
                        <el-option label="女士" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="field-row">
                    <el-form-item prop="regions">
                      <el-cascader :options="districts" :props="regionProps" v-model="newAddress.regions"
                        :clearable="true" placeholder="*请选择地址"></el-cascader>
                    </el-form-item>
                  </div>
                  <div class="field-row">
                    <el-form-item prop="postcode">
                      <el-input type="number" v-model.trim="newAddress.postcode" maxlength="6"
                        placeholder="邮寄编码(选填)"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="fieldset-r">
                  <div class="field-row">
                    <el-form-item prop="mobile">
                      <el-input v-model.trim="newAddress.mobile" maxlength="11" placeholder="*手机号码"></el-input>
                    </el-form-item>
                  </div>
                  <div class="field-row">
                    <el-form-item prop="detail">
                      <el-input v-model.trim="newAddress.detail" maxlength="50" placeholder="*详细地址"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-actions">
                <div class="isdefault" @click="setDefault(!newAddress.isDefault)">
                  <i class="iconfont">{{
                    newAddress.isDefault ? "&#xedaf;" : "&#xec58;"
                  }}</i>
                  <span>设为默认地址</span>
                </div>
                <el-button class="new-address" :disabled="saveStatus" @click="saveAddress">确认</el-button>
                <button class="cancel-address" @click="hideAddressDialog">
                  取消
                </button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付扫码弹窗 -->
    <div class="dialog wait-pay" v-if="payStatus == 'wait'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideWaitPayDialog">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="pay-method">
            <template v-if="paymentMethod == 1 || paymentMethod == 3">
              <i class="iconfont ali-pay">&#xe600;</i>
            </template>
            <template v-else>
              <i class="iconfont wx-pay">&#xe62b;</i>
            </template>
            <span class="pay-name">{{
              ["", "支付宝", "微信支付", "支付宝", "微信支付", "微信支付"][
              paymentMethod
              ]
            }}</span>
          </div>
          <div class="pay-amount">
            支付金额：
            <span class="pay-value" v-if="codeAmount">
              <span class="rmb-symbol">￥</span> {{ codeAmount }}
            </span>
          </div>
          <div class="pay-hits">
            <div class="pay-countdown">
              距离二维码过期还剩<span class="countdown">{{ countdown.m }}分{{ countdown.s }}秒</span>
            </div>
            <div class="pay-msg">过期后请点击刷新重新获取二维码</div>
          </div>
          <div class="pay-code">
            <img :src="payCode" />
            <div v-if="codeMask" class="code-mask" @click="refreshPayCode">
              <span>已失效</span>
            </div>
          </div>
          <div class="pay-method-tips">
            <div class="text">
              打开{{
                ["", "支付宝", "微信", "支付宝", "微信", "微信"][paymentMethod]
              }}扫一扫
            </div>
            <div class="text">扫描上方二维码完成付款</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付成功弹窗 -->
    <div class="dialog pay-success" v-if="payStatus == 'success'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header"></div>
        <div class="dialog-body">
          <div class="pay-result">
            <i class="iconfont">&#xe607;</i>
          </div>
          <div class="pay-ret">支付成功，感谢您的购买</div>
          <div class="pay-msg">包裹将会尽快发出</div>
          <div class="pay-btns">
            <button class="btn view-order" @click="viewOrder">查看订单</button>
            <button class="btn to-shopping" @click="goShopping">
              继续购物
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付结果弹窗 -->
    <div class="dialog pay-unknown" v-if="payStatus == 'unknown'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="viewOrder">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="dialog-subtitle">支付结果</div>
          <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
          <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
          <div class="btn-group">
            <button class="btn" @click="viewOrder">已完成支付</button>
            <button class="btn" @click="orderPay">
              支付遇到问题，重新支付
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="discountPopupVisible && checkoutData">
      <DiscountPopup
        :visible="discountPopupVisible"
        :initData="checkoutData"
        @close="handleDiscountPopupClose"
      />
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import utils from "@/utils";
import { toNumber, isFinite } from 'lodash';
import api from "@/utils/api";
import VueScroll from "vuescroll/dist/vuescroll-native";
import "vuescroll/dist/vuescroll.css";
import { Message } from 'element-ui';
import { captureManualError } from '@/sentry/index'
import DiscountPopup from "@/components/DiscountPopup.vue";

const regEmoji =
  // eslint-disable-next-line no-misleading-character-class
  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/gi;

export default {
  name: "Checkout",
  components: { VueScroll, DiscountPopup },
  data() {
    return {
      districts: [],
      regionProps: {
        value: "name",
        label: "name",
        children: "children",
      },
      // 结算数据
      checkoutData: {},
      // 结算商品
      list: [],
      address: [],
      invoice: null,
      // 交互数据
      shippingMethod: 1,
      selectedAddress: null,
      isAcceptTerms: false,
      showTermsTip: false,
      couponList: [],
      // 结算表单 使用form校验 之前的保留
      checkoutForm: {
        coupon: null,//优惠券
        integral: null,//积分
      },
      checkoutFormRules: {
        integral: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (/^[1-9]\d*00$/.test(value) || value == 0) {
                  callback();
                } else {
                  callback(new Error("积分必须为100倍数的正整数"));
                }
              } else {
                callback();

              }
            },
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              const points = toNumber(this.crm.points);
              if (!isFinite(points) || points >= toNumber(value)) {
                callback();
              } else {
                callback(new Error("超过最大可用积分"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      showAddressDialog: false,
      newAddress: {
        username: "",
        sex: "",
        mobile: "",
        regions: [],
        detail: "",
        postcode: "",
        isDefault: true,
      },
      newAddressRules: {
        username: [
          {
            required: true,
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error("请输入姓名"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择称谓", trigger: "blur" }],
        mobile: [
          {
            validator(fieldRule, value, callback) {
              if (!value) {
                callback(new Error("请输入手机号码"));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("请输入正确的手机号码"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        regions: [
          {
            type: Array,
            validator(rule, value, callback) {
              if (value.length != 3) {
                callback(new Error("请选择地址"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        detail: [
          {
            required: true,
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error("请输入详细地址"));
              } else if (regEmoji.test(value)) {
                callback(new Error("详细地址中不能包含Emoji字符"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      paymentMethod: 1,
      payCode: "",
      countdown: { m: 0, s: 0 },
      codeMask: false,
      payStatus: "",
      orderId: "",
      wsInstance: null,
      orderPayTimer: null,
      codeAmount: 0,
      orderStatusTimer: null,
      discountPopupVisible: false,
    };
  },
  created() {
    // 移动端支付方式处理
    if (utils.isMobile()) {
      if (utils.isWXBrowser()) {
        this.paymentMethod = 5;
        this.allowPayMethod = [
          {
            text: "微信支付",
            value: 5,
            iconCls: "wx-pay",
            iconText: "&#xe62b;",
          },
        ];
      } else {
        this.paymentMethod = 3;
        this.allowPayMethod = [
          {
            text: "支付宝支付",
            value: 3,
            iconCls: "ali-pay",
            iconText: "&#xe600;",
          },
          {
            text: "微信支付",
            value: 4,
            iconCls: "wx-pay",
            iconText: "&#xe62b;",
          },
        ];
      }
    } else {
      this.allowPayMethod = [
        {
          text: "支付宝支付",
          value: 1,
          iconCls: "ali-pay",
          iconText: "&#xe600;",
        },
        { text: "微信支付", value: 2, iconCls: "wx-pay", iconText: "&#xe62b;" },
      ];
    }
    this.loadSource();
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isTaiwanHKMacau(text) {
      return utils.isTaiwanHKMacau(text)
    },
    async loadSource() {
      await this.initAddressInfo();
      await this.initConfirmInfo();

      const hasAccept = utils.checkAndShowCookiePolicy();
      this.$store.commit(types.SHOW_COOKIE_DIALOG, hasAccept);
      
      //更新优惠券列表
      this.loadCouponList();
      //更新crm会员信息
      this.$store.dispatch(types.GET_PROFILE);
    },
    async initAddressInfo() {
      return api[types.GET_CITIES]().then((res) => {
        this.districts = res.data || []
      })
    },
    async initConfirmInfo() {
      const { ids, confirmCacheKey } = this.$route.query;
      if (confirmCacheKey) {
        const res = await this.$store.dispatch('requestCache/getRequestCache', { key: confirmCacheKey });
        if (res) {
          this.handleConfirmInfo(res);
          return
        }
      }
      return api[types.CONFIRM]({ ids })
        .then(res => {
          if (res?.code == 1) {
            this.handleConfirmInfo(res)
          } else {
            console.warn(res);
            setTimeout(() => {
              this.$store.dispatch(types.GET_CART_INFO);
              this.$router.go(-1);
            }, 1000)
          }
        })
    },
    handleConfirmInfo(res) {
      if (res?.data?.list?.length) {
        let { list, address, } =
          res.data;
        this.checkoutData = res.data || {}
        this.list = list;
        this.address = this.toSort(address);
        // 当有地址簿数据时处理默认选中的地址
        if (this.address.length) {
          let ret = this.address.find((item) => item.isDefault);
          if (ret) {
            this.selectedAddress = ret;
          } else {
            this.selectedAddress = this.address[0];
          }
        }
        //
        this.gaTrack4BeginCheckout();
      } else {
        console.warn(res?.data);
        //有可能会清空无库存商品 需要刷新购物车
        this.$store.dispatch(types.GET_CART_INFO);
        this.$router.back();
      }
    },
    loadCouponList() {
      api[types.GET_SETTLE_COUPONLIST]()
        .then((res) => {
          if (res?.code == 1) {
            let { data } = res;
            this.couponList = data;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    gaTrack4BeginCheckout() {
      if (this.list?.length && window.gtag) {
        window.gtag("event", "begin_checkout", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(this.checkoutData.amount),
          items: this.list.map((o) => ({
            item_id: `${o.goodsId}-${o.color.id}`,
            item_name: o.name,
            price: Number(o.price),
            quantity: Number(o.quantity),
            item_brand: "Onitsuka Tiger",
            item_variant: o.color.name,
            currency: "CNY",
          })),
        });
      }
    },
    toSort(items) {
      return items.sort((a, b) => {
        if (a.isDefault < b.isDefault) {
          return 1;
        } else if (a.isDefault > b.isDefault) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    // 设置选中的配送方式
    setShippingMethod(shipping) {
      this.shippingMethod = shipping;
    },
    // 设置选中的配送地址
    setAddress(address) {
      this.selectedAddress = address;
    },
    // 删除地址
    delAddress(address) {
      this.$confirm("确定要删除该地址吗？")
        .then(() => {
          api[types.DEL_ADDRESS]({ id: address.id })
            .then(() => {
              let idx = this.address.findIndex((item) => item.id == address.id);
              if (idx != -1) this.address.splice(idx, 1);
              this.$message({ message: "删除成功" });
              //
              if (this.address.length === 0) {
                this.selectedAddress = null;
              } else if (this.selectedAddress?.id == address.id) {
                this.selectedAddress = this.address[0];
              }
            })
            .catch((err) => {
              console.warn(err);
            });
        })
        .catch(() => { });
    },
    // 编辑地址
    editAddress(address) {
      let newArgs = Object.assign({}, address);
      newArgs.sex && (newArgs.sex += "");
      const regions = utils.isTaiwanHKMacau(newArgs.province) ? [] : [newArgs.province, newArgs.city, newArgs.county]
      newArgs.regions = regions;
      delete newArgs.province;
      delete newArgs.city;
      delete newArgs.county;
      this.newAddress = { ...newArgs };
      this.showAddressDialog = true;
    },
    // 添加地址
    addAddress() {
      console.log('first')
      this.newAddress = {
        username: "",
        sex: "",
        mobile: "",
        regions: [],
        detail: "",
        postcode: "",
        isDefault: true,
      };
      this.showAddressDialog = true;
    },
    // 关闭添加地址弹窗
    hideAddressDialog() {
      this.newAddress = {
        username: "",
        sex: "",
        mobile: "",
        regions: [],
        detail: "",
        postcode: "",
        isDefault: true,
      };
      this.showAddressDialog = false;
    },
    // 新增地址是否为默认地址
    setDefault(isDefault) {
      this.newAddress.isDefault = isDefault;
    },
    // 保存新增的地址
    saveAddress() {
      this.$refs["newAddress"].validate((valid) => {
        if (valid) {
          let newInfo = Object.assign({}, this.newAddress);
          newInfo.province = newInfo.regions[0];
          newInfo.city = newInfo.regions[1];
          newInfo.county = newInfo.regions[2];
          delete newInfo.regions;
          api[types.SAVE_ADDRESS](newInfo)
            .then((res) => {
              if (newInfo.isDefault) {
                this.address.forEach((item) => {
                  item.isDefault = 0;
                });
              }
              if (newInfo.id) {
                let idx = this.address.findIndex(
                  (item) => item.id == newInfo.id
                );
                this.address[idx] = Object.assign(this.address[idx], newInfo);
              } else {
                let newItem = {
                  id: res.data.id,
                  ...newInfo,
                };
                this.address.push(newItem);
                // 如果没有选中的地址
                if (!this.selectedAddress?.id) {
                  this.selectedAddress = newItem;
                }
              }
              this.address = this.toSort(this.address);
              this.showAddressDialog = false;
            })
            .catch((err) => {
              console.warn(err);
            });
        } else {
          return false;
        }
      });
    },
    // 设置选中的支付方式
    setPaymentMethod(paymentMethod) {
      this.paymentMethod = paymentMethod;
    },
    // 设置发票信息
    setInvoice() {
      this.invoice = this.invoice ? null : { title: "", name: "", code: "" };
    },
    setAcceptTerms() {
      this.isAcceptTerms = !this.isAcceptTerms;
      if (this.isAcceptTerms) {
        this.showTermsTip = false;
      }
    },
    // 创建订单
    createOrder() {
      this.$refs['checkoutFormRef'].validate((valid) => {
        if (valid) {
          let { shippingMethod, selectedAddress, paymentMethod, invoice } = this;
          const { integral } = this.checkoutForm
          let newArgs = {
            shippingMethod,
            addressId: selectedAddress.id,
            paymentMethod,
            invoice,
            integral,
          };

          if (utils.isTaiwanHKMacau(selectedAddress?.province)) {
            this.$message({ message: "请填写您的地址信息" });
            return
          }

          this.showTermsTip = false;

          // 检查是否已勾选销售条款
          if (!this.isAcceptTerms) {
            this.showTermsTip = true;
            return;
          }

          // // 移动端支付方式处理
          // if (utils.isMobile()) {
          //   if (utils.isWXBrowser()) {
          //     newArgs.paymentMethod = 5;
          //   } else {
          //     newArgs.paymentMethod = parseInt(newArgs.paymentMethod) + 2;
          //   }
          // }
          // eslint-disable-next-line no-unreachable
          if (!newArgs.invoice) delete newArgs.invoice;
          api[types.CREATE_ORDER](newArgs)
            .then((res) => {
              if (res?.code == 1) {
                let gaItem = [];

                if (window.gtag) {
                  this.list?.forEach((o) => {
                    gaItem.push({
                      item_id: `${o.goodsId}-${o.color.id}`,
                      item_name: o.name,
                      price: Number(o.price),
                      quantity: Number(o.quantity),
                      item_brand: "Onitsuka Tiger",
                      item_variant: o.color.name,
                      currency: "CNY",
                    });
                  });
                  window?.gtag("event", "add_payment_info", {
                    send_to: process.env?.VUE_APP_GA4,
                    currency: "CNY",
                    value: Number(this.checkoutData.amount),
                    items: gaItem,
                    event_category: "add_payment_info",
                  });
                  window?.gtag("event", "add_shipping_info", {
                    send_to: process.env?.VUE_APP_GA4,
                    currency: "CNY",
                    value: Number(this.checkoutData.amount),
                    items: gaItem,
                    event_category: "add_shipping_info",
                  });
                }

                // 更新购物车信息
                this.$store.dispatch(types.GET_CART_INFO);
                // 处理不同的支付方式
                if (newArgs.paymentMethod == 1 || newArgs.paymentMethod == 2) {
                  // 4分钟倒计时
                  this.wsInstance = null;
                  let orderPayTimer = this.startCountdown(
                    res.data.expire,
                    (times, timer) => {
                      if (times > 0) {
                        this.countdown = {
                          m: Math.floor(times / 60),
                          s: times % 60,
                        };
                      } else {
                        this.countdown = { m: 0, s: 0 };
                        this.codeMask = true;
                        this?.wsInstance?.close();
                        timer && clearInterval(timer);
                      }
                    }
                  );
                  this.orderId = res.data.id;
                  this.orderPayTimer = orderPayTimer;
                  this.paymentMethod = newArgs.paymentMethod;
                  this.payCode = res.data?.url;
                  this.payStatus = "wait";
                  this.codeAmount = res.data.amount;
                  // 查询支付状态
                  this.checkOrderStatus(res.data?.id)
                  // this.wsInstance = api[types.QUERY_ORDER_PAY_STATUS](
                  //   this.orderId,
                  //   (evt, ws) => {
                  //     console.log(evt, ws, 'evt, ws');
                  //     if (evt?.data) {
                  //       try {
                  //         let res = JSON.parse(evt.data);
                  //         console.log(res, 'resss');
                  //         if (res?.code == 1) {
                  //           this.showPaySuccess();
                  //           this.$message({ message: "支付成功" });
                  //         } else {
                  //           console.warn(res);
                  //         }
                  //       } catch (err) {
                  //         console.warn(err, evt);
                  //         captureManualError(err)
                  //       } finally {
                  //         ws?.close();
                  //         console.log(`success::clearInterval=>${orderPayTimer}`);
                  //         orderPayTimer && clearInterval(orderPayTimer);
                  //       }
                  //     } else {
                  //       console.warn(evt);
                  //       ws?.close();
                  //       orderPayTimer && clearInterval(orderPayTimer);
                  //     }
                  //   }
                  // );
                } else {
                  //其他支付方式成功付款 获取订单后 如果是付款成功 那么也要上报GA
                  this.orderId = res.data.id;
                  this.getOrderDetail();
                  // this.payStatus = 'unknown';
                  this.$router.replace({
                    path: `/myaccount/orderdetail?id=${res?.data?.id}`,
                  });
                  setTimeout(() => {
                    window.location.href = res?.data?.url;
                  }, 1000)
                }
              } else {
                console.warn(res);
              }
            })
            .catch((res) => {
              if (res?.code == 300) {
                this.$router.replace({ path: "/myaccount/orders" });
              } else if (res?.code == 3001) {
                //积分错误 积分清空
                this.confirmDiscount({ integral: '' })
              } else if (res?.code == 3002) {
                //优惠券错误 清空优惠券
                this.confirmDiscount({ coupon: null })
              } else if (res?.code == 0) {
                //优惠券错误 清空优惠券
                this.$router.replace({ path: "/cart" });
              } else {
                console.log(res)
              }
            });
        }
      })
    },

    //获取订单详情
    getOrderDetail() {
      api[types.ORDER_DETAIL]({ id: this.orderId })
        .then((res) => {
          if (res?.code == 1) {
            let orderInfo = res.data;
            if (orderInfo.status == "待发货") {
              this.gaTrack4Purchase();
            }
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function")
        return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 显示付款扫码弹窗
    showPayDialog() {
      this.payStatus = "wait";
    },
    // 关闭付款扫码弹窗
    hideWaitPayDialog(callback) {
      this.clearOrderPayTimer()
      if (this.orderId) {
        this.wsInstance?.close();
        this.orderPayTimer && clearInterval(this.orderPayTimer);
        this.viewOrder();
      } else {
        this.payStatus = "";
      }
      typeof callback == "function" && callback();
    },
    // 关闭付款扫码弹窗
    hidePayDialog() {
      this.payStatus = "";
      this.clearOrderPayTimer()
    },
    // 刷新付款二维码
    refreshPayCode() {
      this.orderPay();
    },
    orderPay() {
      if (!this.orderId)
        return (
          console.warn(`缺少支付的订单号：(orderId: ${this.orderId})`), false
        );
      api[types.ORDER_PAY]({
        orderId: this.orderId,
        paymentMethod: this.paymentMethod,
      })
        .then((res) => {
          if (res?.code == 1) {
            if (this.paymentMethod == 1 || this.paymentMethod == 2) {
              // 4分钟倒计时
              this.wsInstance = null;
              let orderPayTimer = this.startCountdown(
                res.data.expire,
                (times, timer) => {
                  if (times > 0) {
                    this.countdown = {
                      m: Math.floor(times / 60),
                      s: times % 60,
                    };
                  } else {
                    timer && clearInterval(timer);
                    this.countdown = { m: 0, s: 0 };
                    this.codeMask = true;
                    this?.wsInstance?.close();
                  }
                }
              );
              this.orderPayTimer = orderPayTimer;
              // 查询支付状态
              this.checkOrderStatus(res.data?.id)
              // this.wsInstance = api[types.QUERY_ORDER_PAY_STATUS](
              //   res.data.id,
              //   (evt, ws) => {
              //     if (evt?.data) {
              //       try {
              //         let res = JSON.parse(evt.data);
              //         if (res?.code == 1) {
              //           this.$message({ message: "支付成功" });
              //           this.showPaySuccess();
              //         } else {
              //           console.warn(res);
              //         }
              //       } catch (err) {
              //         console.warn(err, evt);
              //         captureManualError(err)
              //       } finally {
              //         ws?.close();
              //         orderPayTimer && clearInterval(orderPayTimer);
              //       }
              //     } else {
              //       console.warn(evt);
              //       ws?.close();
              //       orderPayTimer && clearInterval(orderPayTimer);
              //     }
              //   }
              // );
              this.payCode = res.data.url;
              this.codeMask = false;
              this.payStatus = "wait";
            } else {
              this.getOrderDetail();
              // this.payStatus = 'unknown';
              this.$router.replace({
                path: `/myaccount/orderdetail?id=${this.orderId}`,
              });
              window.location.href = res.data.url;
            }
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    // 查询支付状态
    checkOrderStatus(id) {
      const intervalId = setInterval(() => {
        if (this.payStatus === 'success') {
          clearInterval(intervalId)
          return
        }
        api[types.ORDER_STATUS]({ id }).then((res) => {
          if (res.code === 1 && res.data.status === 1) {
            this.$message({ message: "支付成功" });
            this.payStatus = "success";
            this.gaTrack4Purchase();
            intervalId && clearInterval(intervalId);
          }
        }).catch((err) => {
          captureManualError(err);
          console.error('查询支付状态失败:', err);
        });

      }, 3000);
      this.orderStatusTimer = intervalId;
    },
    clearOrderPayTimer() {
      this.orderStatusTimer && clearInterval(this.orderStatusTimer);
    },
    gaTrack4Purchase() {
      if (window.gtag) {
        window.gtag("event", "purchase", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          transaction_id: this.orderId,
          shipping: Number(this.checkoutData.shipping),
          value: Number(this.checkoutData.amount),
          items: this.list.map((o) => ({
            item_id: `${o.goodsId}-${o.color.id}`,
            item_name: o.name,
            price: Number(o.price),
            quantity: Number(o.quantity),
            item_brand: "Onitsuka Tiger",
            item_variant: o.color.name,
            currency: "CNY",
          })),
        });
      }
    },
    // 查看订单
    viewOrder() {
      this.$router.replace({
        path: `/myaccount/orderdetail?id=${this.orderId}`,
      });
    },
    // 继续购物
    goShopping() {
      this.$router.push({ path: "/" });
    },
    confirmDiscount(props = {}) {
      this.$refs['checkoutFormRef'].validate((valid) => {
        if (valid) {
          const { coupon, integral } = { ...this.checkoutForm, ...props }
          const { coupon_code: couponCode, crm_coupon_code: crmCouponCode } = this.couponList?.find(i => i.coupon_id === coupon) || {}
          api[types.CHECKOUT_CONFIRM_DISCOUNT]({
            couponCode,
            crmCouponCode,
            integral: integral || '0',
            cartType: ''
          })
            .then((res) => {
              if (res?.code == 1) {
                res.message && Message({
                  message: res.message,
                  type: "warning"
                });
                const { coupon_code, crm_coupon_code, pointsDeducted, points } = res?.data
                //回写优惠券与积分
                this.$store.dispatch('changeCrmPoint', points);
                const selectedItem = this.couponList?.find(
                  (i) => i.coupon_code === coupon_code && i.crm_coupon_code === crm_coupon_code,
                )
                this.checkoutForm.coupon = selectedItem?.coupon_id;
                this.checkoutForm.integral = pointsDeducted || '';
                this.checkoutData = { ...this.checkoutData, ...res?.data }
              } else {
                console.warn(res);
              }
            })
            .catch((err) => {
              console.warn(err);
            });
        } else { return false }
      })
    },
    openDiscountPopup() {
      if(this.isDiscount) {
        this.discountPopupVisible = true;
      }
    },
    handleDiscountPopupClose() {
      this.discountPopupVisible = false;
    },
  },
  computed: {
    // 添加地址按钮状态
    saveStatus() {
      let { username, sex, mobile, regions, detail } = this.newAddress;
      if (
        username &&
        sex &&
        /^1[3456789]\d{9}$/.test(mobile) &&
        regions.length == 3 &&
        detail
      ) {
        return false;
      }
      return true;
    },
    // 订单支付按钮状态
    submitStatus() {
      if (
        this.selectedAddress?.id &&
        (!this.invoice ||
          (this.invoice?.title == 1 && this.invoice?.name) ||
          (this.invoice?.title == 2 &&
            this.invoice?.name &&
            this.invoice?.code))
      ) {
        return false;
      }
      return true;
    },
    crm() {
      return this.$store.state.userInfo?.crm || {};
    },
    commonConfig() {
      return this.$store.state.commonConfig;
    },
    isDiscountDisabled() {
      return this.list?.every((goods) => goods.dont_use_coupon_and_point === 1) ?? false
    },
    checkoutPointTip() {
      const { member_level_list, viptypecode } = this.crm;
      const levelItem = member_level_list?.find(
        (i) => i.crm_member_level_id == viptypecode
      );
      return levelItem?.prompt_text
    },
    calcIsShowCustomerTag() {
      return this.$store.state.isShowCustomerTag
    },
    isDiscount() {
      const { detail_discount = {}, original_subtotal_desc = [], discount_amount } = this.checkoutData || {}
      const discountAmount = discount_amount !== "0.00"
      const hasDetailDiscount = Object.values(detail_discount).some(arr => Array.isArray(arr) && arr.length > 0)
      const hasOriginalSubtotalDesc = Array.isArray(original_subtotal_desc) && original_subtotal_desc.length > 0

      return  discountAmount && (hasDetailDiscount || hasOriginalSubtotalDesc)
    },
    isMobile() {
      return window.innerWidth <= 1024;
    },
  },
  filters: {
    countify(items) {
      if (Array.isArray(items)) {
        return items.reduce((last, current) => last + current.quantity, 0);
      }
      return items;
    },
  },
  beforeDestroy: function () {
    this.clearOrderPayTimer()
  },
};
</script>

<style lang="scss" scoped>
.checkout-wrapper {
  .form-wrapper {
    box-sizing: border-box;
    width: 100%;

    .fieldset {
      display: flex;
      justify-content: space-between;

      .fieldset-l {
        width: calc(50% - 10px);
      }

      .fieldset-r {
        width: calc(50% - 10px);
      }

      .field-row {
        // padding-bottom: 20px;
        display: flex;
        justify-content: space-between;

        & ::v-deep .el-form-item {
          width: 100%;
        }

        &.two-field {

          .username,
          .user-title {
            width: calc(50% - 10px);
          }

          .user-title {
            & ::v-deep .el-form-item__content .el-select {
              width: 100%;
            }
          }
        }

        &.three-field {

          .province,
          .city,
          .county {
            width: calc(100% / 3 - 40px / 3);
          }
        }

        & ::v-deep .el-cascader {
          width: 100%;
        }
      }

      input[type="text"] {
        box-sizing: border-box;
        height: 40px;
        padding-left: 5px;
        border-radius: 2px;
        border: 1px solid rgba(204, 204, 204, 1);

        &:only-child {
          width: 100%;
        }

        &:focus {
          border: 1px solid #000;
        }
      }

      select {
        box-sizing: border-box;
        height: 40px;
      }
    }

    .form-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .isdefault {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .iconfont {
          cursor: pointer;
        }

        span {
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          cursor: pointer;
        }
      }

      .new-address {
        width: 157px;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        // line-height: 40px;
        color: rgba(255, 255, 255, 1);
        background: #7f0019;
        cursor: pointer;

        &[disabled] {
          opacity: 0.2;
          cursor: not-allowed;
        }
      }

      .cancel-address {
        width: 157px;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
        color: rgba(102, 102, 102, 1);
        background: #fff;
        border: 1px solid rgba(231, 231, 231, 1);
        cursor: pointer;
      }
    }
  }
  .item-tag {
    font-size: 10px;
    border: 1px solid #212322;
    padding: 0px 5px;
    margin: 4px 0;
    line-height: 18px;
    color: #212322;
    width: fit-content;
  }

  .page-container {
    box-sizing: border-box;
    max-width: 1200px;
    padding: 30px 20px;
    margin: 0 auto;
    text-align: left;

    .page-header {
      a {
        font-size: 16px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 16px;

        &:hover {
          font-family: unset;
        }
      }

      .page-title {
        margin-top: 40px;
        height: 25px;
        font-size: 25px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 25px;
      }
    }

    .page-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .order-extra {
        box-sizing: border-box;
        width: calc(100% - 520px);
        transition: width 0.25s ease-in;
        padding: 0;

        ::placeholder,
        ::-webkit-input-placeholder,
        ::-moz-placeholder,
        ::-ms-input-placeholder {
          color: rgba(153, 153, 153, 1);
        }

        .extra-item {
          box-sizing: border-box;
          margin-top: 40px;

          // OWHS-10572 - 【OT】联名款及限定款商品结算时不能使用优惠券下单 
           &.discount-disabled ::v-deep{
              *,
              ::placeholder {
                pointer-events: none !important;
                color: #BCBDBF !important;
              }
            }

          .extra-item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 32px;

            .extra-item-title {
              height: 18px;
              font-size: 18px;
              font-weight: 700;
              color: rgba(34, 34, 34, 1);
              line-height: 18px;
            }

            .extra-item-btn {
              width: 120px;
              height: 32px;
              font-size: 14px;
              font-weight: 700;
              color: rgba(51, 51, 51, 1);
              line-height: 32px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(210, 210, 210, 1);
              cursor: pointer;
            }
          }

          .extra-body {
            display: flex;
            margin-top: 10px;
            margin-bottom: 30px;

            .choose-option {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 20px;
              width: 246px;
              height: 50px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(223, 223, 223, 1);
              position: relative;
              cursor: pointer;

              &:first-child {
                margin-left: 0;
              }

              &.active {
                border: 1px solid rgba(0, 0, 0, 1);

                .tick {
                  display: block;
                }

                &::before {
                  content: "";
                  display: block;
                  height: 0;
                  width: 0;
                  font-size: 0;
                  border: 12px solid transparent;
                  border-right: 12px solid #000;
                  border-top: 12px solid #000;
                  position: absolute;
                  top: 0;
                  right: 0;
                }
              }

              .tick {
                display: none;
                position: absolute;
                color: #fff;
                font-size: 14px;
                top: 0px;
                right: 0px;
              }

              .car-icon {
                font-size: 24px;
              }

              .ali-pay {
                font-size: 22px;
                color: rgb(0, 159, 233);
              }

              .wx-pay {
                font-size: 22px;
                color: rgb(79, 163, 42);
              }

              .option-name {
                height: 16px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(34, 34, 34, 1);
                line-height: 16px;
              }
            }

            .address-box {
              box-sizing: border-box;
              width: 100%;
              padding: 25px 20px;
              border: 1px solid rgba(210, 210, 210, 1);

              .address-item {
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                margin-top: 30px;
                cursor: pointer;

                &:first-child {
                  margin-top: 0;
                }

                .address-info {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  flex: 1;
                  max-width: calc(100% - 130px);

                  .address-detail {
                    margin-left: 20px;
                    max-width: calc(100% - 35px);

                    .user-info {
                      display: flex;

                      .username {
                        margin-right: 10px;
                        display: inline-block;
                        max-width: 300px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }
                    }

                    .address-parts {
                      display: block;
                      max-width: 400px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }
                }

                .address-action {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  width: 128px;

                  .default {
                    padding: 0 2px;
                    font-size: 10px;
                    color: rgba(127, 0, 25, 1);
                    line-height: 16px;
                    height: 16px;
                    background: rgba(127, 0, 25, 0.02);
                    border: 1px solid rgba(127, 0, 25, 1);
                  }

                  .no-default {
                    border: none;
                    font-size: 0;
                  }

                  .address-btns {
                    margin-left: 20px;

                    .del-icon {
                      margin-right: 20px;
                    }
                  }
                }
              }
            }

            .invoice-box {
              box-sizing: border-box;
              width: 100%;
              padding: 25px 20px;
              border: 1px solid rgba(210, 210, 210, 1);
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;

              .invoice-switch {
                width: 100%;
                padding-bottom: 20px;

                .invoice-switch-item {
                  display: flex;
                  cursor: pointer;

                  .iconfont {
                    margin-right: 4px;
                  }
                }
              }

              .invoice-title,
              .invoice-name,
              .invoice-code {
                box-sizing: border-box;
                height: 40px;
                width: calc(50% - 10px);
              }

              .invoice-code {
                margin-top: 20px;
              }
            }

            .coupon-box {
              width: 100%;

              ::placeholder {
                color: #666;
              }

              ::v-deep.el-select {
                width: 100%;

                .el-input__inner {
                  border: 1px solid #ACACAC;
                  border-radius: 0;
                  height: 52px;
                  line-height: 52px;
                  color: #000;
                  font-size: 16px;
                  font-weight: 400;
                  padding-left: 16px;
                  padding-right: 36px;

                  ::placeholder {
                    color: #666;
                  }
                }

                .el-input__suffix {
                  right: 14px;

                  .el-select__caret {
                    font-size: 16px;
                    color: #212322;
                  }
                }

                .el-popper {
                  margin: 0;
                  border-radius: 0;
                  box-shadow: none;
                  border: 1px solid #ACACAC;

                  &[x-placement^=bottom] {
                    left: 0 !important;
                    border-top-width: 0;
                  }

                  .el-select-dropdown__wrap {
                    max-height: 180px;

                    .el-select-dropdown__item {
                      height: 66px;
                      border-bottom: 1px solid #eee;
                      padding: 12px 16px;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: #666;

                      .title {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 20px;
                      }

                      .sub-title {
                        margin-top: 4px;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                      }

                      .selected-icon {
                        display: none;
                        font-size: 24px;
                        line-height: 24px;
                      }

                      &.selected {
                        color: #333;

                        .title {}

                        .sub-title {
                          color: #666
                        }

                        .selected-icon {
                          display: block;
                          color: #1C1B1F;
                        }
                      }
                    }
                  }

                  .el-scrollbar__bar.is-vertical {
                    width: 2px;

                    .el-scrollbar__thumb {
                      background: #0000003D;
                    }
                  }

                  .popper__arrow {
                    display: none;
                  }
                }
              }

            }

            .integral-box {
              width: 100%;

              ::placeholder {
                color: #666;
              }

              .el-form-item {
                margin-bottom: 0;
              }

              ::v-deep.el-input {

                .el-input__inner {
                  border: 1px solid #ACACAC;
                  border-radius: 0;
                  height: 52px;
                  line-height: 52px;
                  color: #000;
                  font-size: 16px;
                  font-weight: 400;
                  padding-left: 15px;
                  padding-right: 15px;
                }
              }

              ::v-deep.el-form-item__error {
                color: #F56C6C;
                margin-top: 4px;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
              }

              .extra-tip {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: #999999;
                margin-top: 8px;
              }
            }
          }

          &.shipping-type-box {
            .extra-item-header {
              justify-content: flex-start;

              .shipping-hits {
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 14px;
                margin-left: 8px;
              }
            }
          }

          &.shipping-info-box {
            .extra-item-header {
              .shipping-hits {
                font-size: 14px;
                font-weight: 400;
                color: rgba(152, 0, 7, 1);
                line-height: 14px;
              }
            }
          }

          &.integral-item {
            .points-tip {
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              color: #666666;
            }
          }

          &.payment-box {
            .extra-body {
              .choose-option {
                .option-name {
                  font-size: 18px;
                  margin-left: 7px;
                }
              }
            }
          }

          &.invoice-box {
            .extra-item-header {
              justify-content: flex-start;

              .extra-item-title {
                font-size: 16px;
              }

              .invoice-action {
                cursor: pointer;
                margin-left: 40px;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .iconfont {
                  margin-right: 4px;
                }
              }
            }
          }
        }

        .payment-action {
          margin-top: 40px;
          text-align: center;

          .pay-now {
            width: 100%;
            max-width: 400px;
            height: 40px;
            background: #7f0019;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;

            &[disabled] {
              opacity: 0.2;
              cursor: not-allowed;
            }
          }
        }
      }

      .order-detail {
        box-sizing: border-box;
        width: 400px;

        .extra-item {
          box-sizing: border-box;
          margin-top: 40px;

          .extra-item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 32px;

            .extra-item-title {
              height: 18px;
              font-size: 18px;
              font-weight: 700;
              color: rgba(34, 34, 34, 1);
              line-height: 18px;
            }
          }

          .extra-body {
            display: flex;
            margin-top: 10px;

            &.kv-items {
              flex-direction: column;
              margin-top: 0;
            }

            &.has-discount {
              .kv-line {
                padding-right: 16px;
                position: relative;

                .icon-right-arrow {
                  position: absolute;
                  right: 0;
                  top: 54%;
                  transform: translateY(-50%);
                  cursor: pointer;
                }
              }
            }

            .kv-line {
              display: flex;
              justify-content: space-between;
              align-self: center;
              width: 100%;
              margin-top: 12px;

              .kv-name {
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
              }

              .kv-value {
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;
              }

              &.btmBorder {
                border-bottom: 1px solid #d7d8d8;
              }
            }

            &.goods-items {
              flex-direction: column;
              max-height: 500px;

              .pdp-item {
                margin-top: 20px;

                &:first-child {
                  margin-top: 0;
                }

                .markdown-tip {
                  display: flex;
                  align-items: center;
                  color: #212322;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 20px;
                  margin: 8px 0;

                  &:first-of-type{
                    margin-top: 12px;
                  }
                  &:last-of-type{
                    margin-bottom: 12px;
                  }
                  .iconfont-ot-website {
                    margin-right: 2px;
                  }

                }
              }

              .pdp-item-content {
                display: flex;
                justify-content: flex-start;
                align-self: center;
                width: 100%;


                .pdp-image {
                  box-sizing: border-box;
                  width: 140px;
                  height: 140px;
                  border-radius: 1px;
                  border: 1px solid rgba(223, 223, 223, 1);
                  margin-right: 20px;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  img {
                    width: 120px;
                    height: 120px;
                  }
                }

                .pdp-detail {
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  padding: 10px 0;

                  .pdp-info {
                    .pdp-name {
                      font-size: 14px;
                      font-weight: 400;
                      color: rgba(51, 51, 51, 1);
                      line-height: 20px;

                      a:hover {
                        font-family: unset;
                      }
                    }

                    .pdp-skus {
                      display: flex;
                      justify-content: flex-start;
                      flex-wrap: wrap;
                      margin-top: 10px;

                      .pdp-sku-item {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 14px;
                        margin-right: 20px;
                      }
                    }
                  }

                  .pdp-subTotal {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;

                    .pdp-count,
                    .pdp-money {
                      font-size: 14px;
                      font-weight: 700;
                      color: rgba(51, 51, 51, 1);
                      line-height: 20px;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    }

                    .item-original_price {
                      font-weight: 400;
                      color: #999;
                      line-height: 20px;
                      text-decoration: line-through;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .order-extra-pay {
        display: none;
        box-sizing: border-box;
        width: 100%;
        margin-top: 40px;
        text-align: center;

        .pay-now {
          width: 400px;
          max-width: 100%;
          height: 40px;
          background: #7f0019;
          font-size: 14px;
          font-weight: 500;
          color: white;
          cursor: pointer;

          &[disabled] {
            opacity: 0.2;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  .dialog {
    width: 0;
    height: 0;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 990; //低于header1000
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;

      .dialog-header {
        position: relative;
        text-align: left;
      }

      .dialog-body {
        display: flex;
      }
    }

    &.new-address-dialog {
      .dialog-container {
        width: 726px;
        min-height: 341px;
        padding: 30px 40px 40px 40px;

        .dialog-header {
          .dialog-title {
            font-size: 20px;
            color: rgba(34, 34, 34, 1);

            .title-hits {
              font-size: 14px;
              color: rgba(139, 0, 19, 1);
            }
          }

          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          .form-wrapper {
            margin-top: 30px;

            .form-actions {
              .cancel-address {
                display: none;
              }
            }
          }
        }
      }
    }

    &.wait-pay {
      .dialog-container {
        width: 470px;
        height: 570px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          align-items: center;

          .pay-method {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 45px;

            .iconfont {
              font-size: 40px;

              &.ali-pay {
                color: rgb(0, 159, 233);
              }

              &.wx-pay {
                color: rgb(79, 163, 42);
              }
            }

            .pay-name {
              font-size: 20px;
              margin-left: 10px;
            }
          }

          .pay-amount {
            font-size: 14px;
            color: #666666;
            margin-top: 20px;

            .pay-value {
              font-size: 25px;
              color: #8b0013;
            }
          }

          .pay-hits {
            height: 40px;
            margin-top: 18px;

            .pay-countdown,
            .pay-msg {
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              text-align: center;

              .countdown {
                color: #8b0013;
              }
            }
          }

          .pay-code {
            margin-top: 10px;
            position: relative;

            img {
              width: 190px;
              height: 190px;
            }

            .code-mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              span {
                color: #fff;
              }
            }
          }

          .pay-method-tips {
            height: 40px;
            margin-top: 10px;

            .text {
              font-size: 14px;
              line-height: 20px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }

    &.pay-success {
      .dialog-container {
        width: 472px;
        height: 326px;

        .dialog-body {
          flex-direction: column;

          .pay-result {
            margin-top: 45px;

            .iconfont {
              font-size: 64px;
              color: rgb(30, 190, 75);
            }
          }

          .pay-ret {
            margin-top: 2px;
            font-size: 18px;
            font-weight: 700;
            color: #222222;
          }

          .pay-msg {
            margin-top: 12px;
            font-size: 16px;
            color: rgb(105, 115, 135);
          }

          .pay-btns {
            margin-top: 40px;

            .btn {
              font-size: 14px;
            }

            .view-order {
              background: #fff;
              color: #999999;
              border: 1px solid #dfdfdf;
            }

            .to-shopping {
              margin-left: 20px;
            }
          }
        }
      }
    }

    &.pay-unknown {
      .dialog-container {
        width: 472px;
        height: 310px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .dialog-subtitle {
            font-size: 16px;
            color: #333333;
            font-weight: 700;
            margin-top: 40px;
          }

          .txt-line {
            font-size: 14px;
            color: #666666;

            &.mt20 {
              margin-top: 20px;
            }
          }

          .btn-group {
            margin-top: 28px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 20px;
                color: #666666;
                background: #ffffff;
                border: 1px solid #e7e7e7;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .checkout-wrapper {
    .form-wrapper {
      .fieldset {
        flex-direction: column;

        .fieldset-l,
        .fieldset-r {
          width: 100%;
        }
      }
    }

    .page-container {
      .page-content {
        .order-extra {
          width: calc(100% - 440px);

          .extra-item {
            &.shipping-type-box {
              .extra-item-header {
                flex-direction: column;
                align-items: flex-start;

                .shipping-hits {
                  margin-top: 5px;
                  margin-left: 0;
                }
              }
            }

            &.invoice-box {
              .extra-body {
                .invoice-box {

                  .invoice-title,
                  .invoice-name,
                  .invoice-code {
                    width: 100%;
                  }

                  .invoice-name {
                    margin-top: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 960px) {
  .checkout-wrapper {
    .page-container {
      .page-content {
        .order-extra {
          .extra-item {
            &.shipping-info-box {
              .extra-item-header {
                .extra-item-btn {
                  border: none;
                  width: auto;
                  padding: 0;
                  text-decoration: underline;
                }
              }

              .extra-body {
                .address-box {
                  padding: 0;
                  border: none;

                  .address-item {
                    flex-direction: column;
                    align-items: flex-start;
                    border: 1px solid #d2d2d2;
                    padding: 10px;

                    .address-info {
                      width: 100%;
                      margin-bottom: 10px;
                    }

                    .address-action {
                      width: 100%;
                      justify-content: space-between;
                      border-top: 1px solid #d2d2d2;
                      padding-top: 10px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .checkout-wrapper {
    .page-container {
      .page-content {
        flex-direction: column;

        .order-extra {
          width: 100%;

          .extra-item {
            &.invoice-box {
              .extra-body {
                .invoice-box {

                  .invoice-title,
                  .invoice-name,
                  .invoice-code {
                    width: calc(50% - 10px);
                  }

                  .invoice-name {
                    margin-top: 0px;
                  }
                }
              }
            }
          }

          .payment-action {
            display: none;
          }
        }

        .order-detail {
          width: 100%;
          display: flex;
          flex-direction: column-reverse;
          position: relative;
          margin-top: 10px;

          .order-summary-box {
            margin-top: 20px;
            padding-top: 24px;
            border-top: 1px solid #dfdfdf;
          }

          &::after {
            content: "";
            position: absolute;
            width: calc(100% + 40px);
            top: 0;
            left: -20px;
            height: 6px;
            background: #f7f7f7;
          }
        }

        .order-extra-pay {
          display: block;
        }
      }
    }

    .dialog.pay-unknown {
      .dialog-container {
        width: 285px;
        height: 225px;

        .dialog-body {
          .dialog-subtitle {
            margin-top: 8px;
          }

          .txt-line {
            font-size: 12px;
          }

          .btn-group {
            margin-top: 20px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 375px) {
  .checkout-wrapper {
    .page-container {
      padding: 0;

      .page-header {
        display: none;
      }

      .page-content {
        .order-extra {
          .spliter {
            display: block;
            height: 10px;
            background: rgba(248, 248, 248, 1);
          }

          .extra-item {
            padding: 0 20px;
            margin-top: 30px;

            .extra-item-header {
              .extra-item-title {
                font-size: 14px;
              }
            }

            .extra-body {
              .coupon-box {
                .el-form-item {
                  margin-bottom: 0;
                }

                ::v-deep.el-select {
                  .el-input__inner {
                    height: 48px;
                    line-height: 48px;
                    font-size: 12px;
                    font-weight: 400;
                    padding-left: 12px;
                    padding-right: 36px;
                  }

                  .el-input__suffix {
                    right: 12hpx;
                  }

                  .el-select-dropdown__wrap {
                    max-height: 162px;

                    .el-select-dropdown__item {
                      height: 62px;
                      padding: 12px;

                      .title {
                        font-size: 12px;
                        line-height: 28px;
                      }

                      .sub-title {
                        font-size: 10px;
                        line-height: 16px;
                      }
                    }
                  }
                }
              }

              .integral-box {
                ::v-deep.el-input {
                  .el-input__inner {
                    height: 48px;
                    line-height: 48px;
                    font-size: 12px;
                    font-weight: 400;
                  }
                }

                ::v-deep.el-form-item__error {
                  color: #F56C6C;
                  margin-top: 8px;
                  font-size: 10px;
                  line-height: 16px;
                }

                .extra-tip {
                  font-size: 10px;
                  line-height: 16px;
                }
              }
            }

            &.shipping-type-box {
              .extra-item-header {
                .shipping-hits {
                  font-size: 12px;
                }
              }

              .extra-body {
                .choose-option {
                  width: 100%;
                }
              }
            }

            &.shipping-info-box {
              .extra-item-header {
                .shipping-hits {
                  font-size: 12px;
                }
              }

              .extra-body {
                .address-box {
                  .fieldset {
                    .fieldset-l {
                      .two-field {
                        flex-direction: column;

                        .username {
                          width: 100%;
                          margin-bottom: 20px;
                        }

                        .user-title {
                          width: 100%;
                        }
                      }

                      .three-field {
                        flex-direction: column;

                        .province {
                          width: 100%;
                          margin-bottom: 20px;
                        }

                        .city {
                          width: 100%;
                          margin-bottom: 20px;
                        }

                        .county {
                          width: 100%;
                        }
                      }
                    }
                  }

                  .form-actions {
                    flex-direction: column;

                    .isdefault {
                      align-self: flex-start;
                      margin-bottom: 20px;
                    }

                    .new-address {
                      width: 100%;
                    }
                  }

                  .address-item {
                    .address-info {
                      .address-detail {
                        margin-left: 10px;
                      }
                    }
                  }
                }
              }
            }

            &.integral-item {
              margin-top: 32px;

              .points-tip {
                font-size: 12px;
                line-height: 18px;
              }
            }

            &.invoice-box {
              .extra-item-header {
                justify-content: space-between;

                .extra-item-title {
                  font-size: 14px;
                }

                .invoice-action {
                  display: flex;
                  flex-direction: row-reverse;
                }
              }

              .extra-body {
                .invoice-box {

                  .invoice-title,
                  .invoice-name,
                  .invoice-code {
                    width: 100%;
                  }

                  .invoice-name {
                    margin-top: 20px;
                  }
                }
              }
            }
          }
        }

        .order-detail {
          border-top: 10px solid rgba(248, 248, 248, 1);
          padding: 0 20px;
          display: flex;
          flex-direction: column-reverse;

          .extra-item {
            margin-top: 20px;

            .extra-item-header {
              .extra-item-title {
                font-size: 14px;
              }
            }

            &.order-summary-box {
              border-top: 1px solid rgba(238, 238, 238, 1);
              padding-top: 24px;

              .kv-items {
                margin-top: 4px;
                margin-bottom: 30px;

                .kv-name {
                  font-size: 12px;
                  line-height: 18px;
                }

                .kv-value {
                  font-size: 14px;
                  line-height: 20px;
                }
              }
            }

            &.order-detail-box {
              .goods-items {
                .pdp-item {
                  .markdown-tip {
                    font-size: 12px;
                    line-height: 18px;
                    margin: 4px 0;
                  }

                  .iconfont-ot-website {
                    font-size: 12px;
                  }
                }

                .pdp-item-content {
                  .pdp-image {
                    width: 90px;
                    height: 90px;
                    padding: 2px;

                    img {
                      width: 100%;
                      height: auto;
                    }
                  }

                  .pdp-detail {
                    padding: 0;

                    .pdp-info {

                      .pdp-name,
                      .pdp-name a {
                        font-size: 12px;
                        line-height: 16px;
                      }

                      .pdp-skus {
                        .pdp-sku-item {
                          font-size: 12px;
                          line-height: 12px;

                          .sku-name,
                          .sku-value {
                            font-size: 12px;
                          }
                        }
                      }
                    }

                    .pdp-subTotal {

                      .pdp-count,
                      .pdp-money {
                        font-size: 12px;
                        font-weight: 400;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .order-extra-pay {
          margin-top: 0;
          border-top: 10px solid rgba(248, 248, 248, 1);
          padding: 40px 20px;

          .pay-now {
            width: 100%;
          }
        }
      }
    }

    .dialog.new-address-dialog {
      .dialog-container {
        padding: 20px;
        max-width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(0, 0);

        .dialog-body {
          .form-wrapper {
            .fieldset {
              .fieldset-l {
                .two-field {
                  flex-direction: column;

                  .username {
                    width: 100%;
                    margin-bottom: 20px;
                  }

                  .user-title {
                    width: 100%;
                  }
                }

                .three-field {
                  flex-direction: column;

                  .province {
                    width: 100%;
                    margin-bottom: 20px;
                  }

                  .city {
                    width: 100%;
                    margin-bottom: 20px;
                  }

                  .county {
                    width: 100%;
                  }
                }
              }
            }

            .form-actions {
              flex-direction: column;

              .isdefault {
                align-self: flex-start;
                margin-bottom: 20px;
              }

              .new-address {
                width: 100%;
              }

              .cancel-address {
                display: block;
                width: 100%;
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }
}
.accept-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  padding-bottom: 10px;

  .accept-content {
    display: flex;
    align-items: center;
    flex-direction: row;

    .iconfont {
      cursor: pointer;
    }

    span {
      color: red;
      margin-left: 6px;
    }
    a {
      text-decoration: underline;
    }
  }

  .tip {
    color: red;
    font-size: 13px;
  }
}
@media (max-width: 768px) { 
  .accept-box-m{
    display: block;
    margin-top: 20px;
    padding-bottom: 0;
    position: relative;
    padding-top: 20px;

    ::after {
      position: absolute;
      width: calc(100% + 40px);
      top: 0;
      left: -20px;
      content: '';
      display: block;
      clear: both;
      height: 6px;
      background: #f7f7f7;
    }
  }
  .accept-box-p{
    display: none;
  }
}
@media (min-width: 768px) { 
  .accept-box-m{
    display: none;
  }
  .accept-box-p{
    display: block;
  }
}
</style>
